import { render, staticRenderFns } from "./ProfileIcon.vue?vue&type=template&id=2f89239d&scoped=true&"
import script from "./ProfileIcon.vue?vue&type=script&lang=ts&"
export * from "./ProfileIcon.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileIcon.vue?vue&type=style&index=0&id=2f89239d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f89239d",
  null
  
)

export default component.exports